module.exports = __webpack_public_path__ + "img/queue.978a4f6e.svg";